module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-logo-03e269ac56ea258f8b2a0ae215e840ce.svg";